import { OPEN_KEYS_BY_PATH } from './menu.constants';

export default {};

export const formatMenuItem = (pathname) => {
  let menuItem = pathname?.substring(1) ?? '';

  if (menuItem.startsWith('forms/')) {
    menuItem = 'forms';
  }
  return menuItem;
};

export const getOpenKeys = (pathname) => {
  if (!pathname) return [];
  if (pathname.startsWith('projects/type/')) {
    return ['projects'];
  }
  return OPEN_KEYS_BY_PATH[pathname] ?? [];
};
